import React from "react";
import HubspotBanner from "../../hubspot/HubspotBanner";
import store from "../../../state/store";

const ThrottlingMessage = () => (
  <div>
    <div className="tw-text-center tw-text-red-700 tw-text-base">
      <div className="tw-py-1">
        You have exceeded the maximum number of queries for which
        Germline/Somatic classification and publication data is included.
      </div>
      <div className="tw-py-1">This will reset in 24 hours.</div>
      <div className="tw-py-1">
        For unlimited access, consider upgrading to one of the following:
      </div>
    </div>
    <div className="tw-justify-center tw-flex">
      <HubspotBanner
        bannerId="3ff49e19-af21-4d17-87a3-72c468154cd7"
        altText={varsomeConfig.field_descriptions?.acmgThrottlingMessage || ""}
        altUrl={`${
          store.getState().varsomeHost
        }/varsome-editions/varsome-premium`}
        throttling={true}
      />
    </div>
  </div>
);

export default ThrottlingMessage;
